{
    "AddCRMTitle": "Ajouter l'intégration CRM",
    "ModififyCRMTitle": "Modifier l'intégration CRM",
    "CRMDetailsTitle": "Détails",
    "CRMGeneralIDLabel": "IDENTIFIANT",
    "CRMDetailsIDLabelPlaceholder": "[Attribué automatiquement]",
    "CRMDetailsDescriptionLabel": "Description",
    "CRMValidationDescriptionLabel": "La description est obligatoire",
    "NAME": "CRMModal",
    "CRMScopeTitle": "Portée",
    "CRMConfigurationTitle": "Configuration",
    "CRMConfigurationCRMTypeLabel": "CRM",
    "CRMConfigurationTypeNone": "Aucun",
    "CRMConfigurationTab_Setting_Name": "Nom du paramètre",
    "CRMConfigurationTab_Value": "Valeur"
}